import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RouterGuard } from './shared/guard/router.guard';

const routes: Routes = [
  { path: '', redirectTo: '', pathMatch: 'full', canActivate: [RouterGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
